import { useRef } from 'react';

import type { Screen } from '~/types/screen/Screen';

export type LegacyBeatMemory = { clientID: string; at?: number };

/** Garde le plus récent battement « ancienne version » vu (remis à zéro au changement d'établissement). */
export function rememberLegacyBeat(prev: LegacyBeatMemory, clientID: string, screen?: Screen): LegacyBeatMemory {
    const base = prev.clientID === clientID ? prev : { clientID };
    const beat = screen?.legacyBeat();
    if (beat === undefined || (base.at !== undefined && beat <= base.at)) return base;
    return { clientID, at: beat };
}

/**
 * Mémorise le dernier battement d'une page TV restée sur l'ANCIENNE version
 * (`Screen.legacyBeat()`). Un instantané Firestore ne montre que la dernière
 * écriture : dès qu'un téléphone bat après elle, la TV ancienne version devient
 * invisible et la carte « La TV tourne sur un téléphone » clignoterait à chaque
 * minute. La télécommande suit l'écran en direct, elle voit passer chaque
 * battement : on garde le plus récent.
 */
export function useLegacyBeat(clientID: string, screen?: Screen): number | undefined {
    const ref = useRef<LegacyBeatMemory>({ clientID });
    ref.current = rememberLegacyBeat(ref.current, clientID, screen);
    return ref.current.at;
}
